import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';
const entity = 'UI_TODOLIST';

const en = {
    expand_tooltip: 'Expand',
    more_actions_tooltip: 'More actions',
    setting: 'Settings',
    delete: 'Delete',
    empty_state: 'Your open tasks will appear here.',
    view_more: 'To see more items, enter the X form',
    assigned_to_me: 'Assigned to me',
    remarks_tooltip: 'Add or view remarks',
    dialog_tooltip: 'Add or view internal dialogue',
    setting_tooltip: 'Choose which fields you want to appear in the widget.',
    delete_tooltip: 'Delete widget',
    search_placeholder: 'Search...',
    statuses_no_results:
        'We did not find a status that matches your search. Check your spelling and try again.',
    promos_title: 'To Do List Widget',
    promos_content:
        'See exactly what you need to do as soon as you enter Priority.\nAdd the To Do List to your home page to prioritize, add comments, and update the status of the task or document.',
    promo_approve: 'Add to home page',
    promo_decline: 'Don’t show me again',
    promos_toast_msg: 'We added the To Do List widget to your home page.'
};

const he = {
    expand_tooltip: 'הרחבה',
    more_actions_tooltip: 'פעולות נוספות',
    setting: 'הגדרות',
    delete: 'מחיקה',
    empty_state: 'הנושאים הפתוחים לביצוע יופיעו כאן.',
    view_more: 'אפשר לצפות בנושאים פתוחים נוספים במסך X',
    assigned_to_me: 'לטיפולי',
    remarks_tooltip: 'אפשר לרשום טקסט לתעודה',
    dialog_tooltip: 'אפשר לרשום טקסט לשימוש פנימי',
    setting_tooltip: "כאן בוחרים אילו שדות יופיעו בוודג'ט.",
    delete_tooltip: "מחיקת הוודג'ט",
    search_placeholder: 'חיפוש...',
    statuses_no_results: 'לא מצאנו סטטוס שמתאים לחיפוש שלך. כדאי לבדוק את האיות ולנסות שוב.',
    promos_title: 'ווידג’ט נושאים לביצוע',
    promos_content:
        'הוסיפו את הווידג’ט רשימת נושאים לביצוע למסך הבית.\nעם הכניסה ל- Priority, תוכלו לראות את הווידג’ט האינטראקטיבי שמפרט את הנושאים שלכם לביצוע. תוכלו לצפות במשימות ובתעודות שלכם, לתעדף, להוסיף הערות, ולעדכן סטטוס ישירות בדף הבית.',
    promo_approve: 'הוספה לדף הבית',
    promo_decline: 'לא להציג שוב',
    promos_toast_msg: 'הוספנו את הווידג’ט רשימת נושאים לביצוע לדף הבית.'
};

const fallbacks = {en, he};

export const mapping = {
    1: 'title',
    2: 'expand_tooltip',
    3: 'more_actions_tooltip',
    4: 'setting',
    5: 'delete',
    6: 'empty_state',
    7: 'view_more',
    8: 'assigned_to_me',
    10: 'remarks_tooltip',
    11: 'dialog_tooltip',
    16: 'setting_tooltip',
    17: 'delete_tooltip',
    18: 'search_placeholder',
    19: 'statuses_no_results',
    20: 'promos_title',
    21: 'promos_content',
    22: 'promo_approve',
    23: 'promo_decline',
    24: 'promos_toast_msg'
};

export const getServerTexts = () => getTexts(entity, mapping);

initTexts(entity, fallbacks);

export default texts[entity];
